module.exports = __webpack_public_path__ + "static/media/image27.74226921.JPG";